import { Dispatch } from 'react';
import { SuSyApi } from '../../api/susyApi';
import { VersionActionType } from '../actionTypes/version';
import { PostDispatch } from '../types';

export const getLatestVersion =
    () => async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.get('/releaseChangelog/latestVersion');

        dispatch({
            type: VersionActionType.GET_LATEST_VERSION,
            payload: response.data,
        });
    };
